import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from '../ValidationElement';
import SvgComponent from '../SvgComponent';
import Radio from '../Radio';
import RadioGroup from '../RadioGroup';

export default class Sex extends ValidationElement {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  /**
   * Handle the change event.
   */
  handleUpdate(values) {
    this.props.onUpdate({
      value: values.value,
    });
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `sex.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  divClass() {
    return `${this.props.className || ''} sex`;
  }

  render() {
    return (
      <div className={this.divClass()}>
        <label id="sex">{this.props.label}</label>
        <RadioGroup
          attribute={this.props.attribute}
          className="option-list physical-radio"
          selectedValue={this.props.value}
          onError={this.props.onError}
          required={this.props.required}
        >
          <Radio
            name={this.props.name}
            label={i18n.t('identification.traits.sex.female')}
            placeholder={this.props.placeholder}
            value="Female"
            className="female"
            onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          >
            <div className="sex-icon">
              <SvgComponent src="/img/female.svg" />
            </div>
          </Radio>
          <Radio
            name={this.props.name}
            label={i18n.t('identification.traits.sex.male')}
            placeholder={this.props.placeholder}
            value="Male"
            className="male"
            onUpdate={this.handleUpdate} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          >
            <div className="sex-icon">
              <SvgComponent src="/img/male.svg" />
            </div>
          </Radio>
        </RadioGroup>
      </div>
    );
  }
}

Sex.defaultProps = {
  value: '',
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};

Sex.errors = [];
